import React from "react";
import { motion } from "framer-motion";

/**
 * SectionHeader — editorial-style: overline + display headline + optional lede.
 */
const SectionHeader = ({ overline, title, lede, align = "left", number, action, testId }) => {
  return (
    <div className={`${align === "center" ? "text-center" : ""}`} data-testid={testId}>
      <div className={`flex ${align === "center" ? "justify-center" : "justify-start"} items-center gap-4 mb-6`}>
        {overline && <div className="overline">{overline}</div>}
        {number && <div className="text-[11px] font-mono-editorial tracking-[0.22em] text-ink-muted">{number}</div>}
      </div>
      <div className={`flex ${align === "center" ? "justify-center" : "justify-between"} items-end gap-6 flex-wrap`}>
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-ink font-normal text-4xl md:text-5xl lg:text-[60px] leading-[1.05] tracking-tight max-w-4xl"
        >
          {title}
        </motion.h2>
        {action}
      </div>
      {lede && (
        <p className={`mt-6 text-ink-soft text-base md:text-lg leading-relaxed max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>
          {lede}
        </p>
      )}
      <div className="hairline mt-10" />
    </div>
  );
};

export default SectionHeader;
